import { numberSorter } from '../sorters';
export const byCreatedAt = (a, b)=>numberSorter(a === null || a === void 0 ? void 0 : a.createdAt, b === null || b === void 0 ? void 0 : b.createdAt);
